import { render, staticRenderFns } from "./mobile-contact.vue?vue&type=template&id=38b93161&scoped=true&"
import script from "./mobile-contact.vue?vue&type=script&lang=js&"
export * from "./mobile-contact.vue?vue&type=script&lang=js&"
import style0 from "./mobile-contact.vue?vue&type=style&index=0&id=38b93161&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b93161",
  null
  
)

export default component.exports